import React, { createContext, useContext, useState, useEffect } from 'react';

const GlobalContext = createContext();

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobalContext must be used within a GlobalContextProvider');
  }
  return context;
};

export const GlobalContextProvider = ({ children }) => {
  // Initialize state from localStorage or default values
  const [imagesActive, setImagesActive] = useState(() => {
    const stored = localStorage.getItem('imagesActive');
    return stored !== null ? JSON.parse(stored) : true; // default to true
  });

  const [numbersActive, setNumbersActive] = useState(() => {
    const stored = localStorage.getItem('numbersActive');
    return stored !== null ? JSON.parse(stored) : false; // default to false
  });

  const [tokenSearchVal, setTokenSearchVal] = useState('');

  const [darkMode, setDarkMode] = useState(() => {
    const stored = localStorage.getItem('darkMode');
    return stored !== null ? JSON.parse(stored) : false; // default to false (light mode)
  });

  const handleNumberClick = () => {
    setNumbersActive(true);
    setImagesActive(false);
    localStorage.setItem('numbersActive', JSON.stringify(numbersActive));
    localStorage.setItem('imagesActive', JSON.stringify(false));
  };

  const handleImageClick = () => {
    setImagesActive(true);
    setNumbersActive(false);
    localStorage.setItem('imagesActive', JSON.stringify(true));
    localStorage.setItem('numbersActive', JSON.stringify(false));
  };

  const toggleDarkMode = () => {
    setDarkMode(prev => {
      const newValue = !prev;
      localStorage.setItem('darkMode', JSON.stringify(newValue));
      return newValue;
    });
  };

  // Update localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem('imagesActive', JSON.stringify(imagesActive));
  }, [imagesActive]);

  useEffect(() => {
    localStorage.setItem('numbersActive', JSON.stringify(numbersActive));
  }, [numbersActive]);

  // Apply dark mode class to body
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  const value = {
    imagesActive,
    numbersActive,
    handleNumberClick,
    handleImageClick,
    tokenSearchVal,
    setTokenSearchVal,
    darkMode,
    toggleDarkMode,
  };

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
};

